<template>
  <CreateUpdateTemplate
    :routePreventDialog="routePreventDialog"
    :hasChanges="hasChanges"
    :customClass="'create-project create-form'"
    v-if="getPermission('project:create') || getPermission('project:update')"
  >
    <template v-slot:header-title>
      <div class="d-flex justify-space-between">
        <h1 class="form-title text-truncate d-flex align-baseline">
          Project for
          <div
            v-if="vCustomerId"
            class="ml-3 form-title-link cursor-pointer text-h5"
            v-on:click="openDialog('customer')"
          >
            {{ vCustomer.display_name }}
          </div>
          <template v-else>
            <div
              class="ml-3 form-title-link cursor-pointer text-h5"
              v-on:click="openDialog('customer')"
            >
              Select a Customer
              <v-icon large color="cyan">mdi-account-check-outline</v-icon>
            </div>
            <div class="mx-3">OR</div>
            <div
              class="form-title-link cursor-pointer cyan--text text--darken-4 text-h5"
              v-on:click="createCustomerDialog()"
            >
              Create a new Customer
              <v-icon large color="cyan darken-4"
                >mdi-plus-circle-outline</v-icon
              >
            </div>
          </template>
        </h1>
        <v-chip
          label
          color="chip-custom-blue"
          outlined
          class="text-white p-3 mr-4"
          style="font-size: 21px !important; font-weight: 700"
        >
          <template>
            {{ projectCreate.barcode }}
          </template>
        </v-chip>
      </div>
    </template>
    <template v-slot:header-action>
      <div>
        <v-btn
          :disabled="formLoading"
          v-on:click="goBack()"
          class="custom-bold-button custom-grey-border"
          depressed
          >Cancel</v-btn
        >
        <v-btn
          class="custom-bold-button ml-4"
          depressed
          :disabled="!formValid || formLoading"
          :loading="formLoading"
          v-on:click="validateJob()"
          color="cyan white--text"
        >
          {{ project_Id > 0 ? "Update" : "Save" }}
        </v-btn>
      </div>
    </template>
    <template v-slot:body>
      <perfect-scrollbar
        :options="{ suppressScrollX: true }"
        class="scroll custom-box-top-inner-shadow product-create-height"
        style="position: relative"
      >
        <div class="bg-white px-2">
          <v-form
            ref="projectForm"
            v-model.trim="formValid"
            lazy-validation
            v-on:submit.stop.prevent="validateJob()"
          >
            <v-row>
              <v-col md="7">
                <label for="project-title" class="required">Project Name</label>
                <TextField
                  id="Project-title"
                  dense
                  filled
                  placeholder="Project Name"
                  solo
                  flat
                  counter="150"
                  v-model="projectCreate.name"
                  color="cyan"
                  :maxlength="250"
                  :rules="[
                    validateRules.required(projectCreate.name, 'Project Name'),
                    validateRules.required(projectCreate.name, 'Project Name'),
                    validateRules.minLength(
                      projectCreate.name,
                      'Project Name',
                      1
                    ),
                    validateRules.maxLength(
                      projectCreate.name,
                      'Project Name',
                      150
                    ),
                  ]"
                />

                <TextAreaField
                  auto-grow
                  dense
                  filled
                  color="cyan"
                  v-model.trim="projectCreate.description"
                  placeholder="Description"
                  solo
                  flat
                  row-height="25"
                  counter="250"
                />
                <v-row>
                  <v-col md="6">
                    <v-layout class="align-center">
                      <v-flex md3
                        ><label class="my-0">Billing Location</label></v-flex
                      >
                      <v-flex md9 class="position-relative">
                        <v-icon
                          v-on:click="openDialog('billing')"
                          small
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        >
                      </v-flex>
                    </v-layout>
                    <template v-if="vBilling?.id">
                      <span v-if="vBilling && vBilling.property_address">
                        <!--  <v-icon small>mdi-map-marker</v-icon> --></span
                      >
                      <template>
                        <div
                          class="custom-flex-d"
                          v-if="vBilling.property_name"
                        >
                          <b>
                            <v-icon
                              style="
                                font-size: 18px;
                                margin-top: -3px !important;
                              "
                              color="#000"
                              class="cmt-2"
                            >
                              mdi-home-map-marker
                            </v-icon>
                          </b>
                          <span>{{ vBilling.property_name }}<br /></span>
                        </div>
                        <div v-else>
                          <em class="text-muted">
                            <v-icon
                              style="
                                font-size: 18px;
                                margin-top: -3px !important;
                              "
                              color="#000"
                              class="cmt-2"
                            >
                              mdi-home-map-marker
                            </v-icon>
                            no Site Name</em
                          >
                        </div>
                      </template>

                      <template>
                        <div class="custom-flex-d">
                          <b>
                            <v-icon
                              style="
                                font-size: 18px;
                                margin-top: -3px !important;
                              "
                              color="#000"
                              class="cmt-2"
                            >
                              mdi-map-marker
                            </v-icon>
                          </b>
                          <span>
                            <template v-if="vBilling.unit_no"
                              >{{ vBilling.unit_no }},</template
                            >
                            <template v-if="vBilling.street_1"
                              >{{ vBilling.street_1 }},</template
                            >
                            {{ vBilling.street_2 }}
                            <br />
                            {{ vBilling.country }}
                            <template
                              v-if="
                                vBilling.zip_code &&
                                vBilling.zip_code != '000000'
                              "
                            >
                              {{ vBilling.zip_code }}
                            </template>
                          </span>
                        </div>
                      </template>
                    </template>
                    <template v-else-if="vCustomer?.id">
                      <p class="mb-0 red--text">
                        Please select billing location
                      </p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select customer</p>
                    </template>
                    <v-layout class="mt-3 align-center">
                      <v-flex md3
                        ><label class="my-0">Contact Details</label></v-flex
                      >
                      <v-flex md9 class="position-relative">
                        <v-icon
                          small
                          v-on:click="openDialog('billing-contact')"
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        >
                      </v-flex>
                    </v-layout>
                    <template v-if="vBillingContact?.id">
                      <p class="mb-0">{{ vBillingContact.display_name }}</p>
                      <p class="mb-0">{{ vBillingContact.primary_phone }}</p>
                      <p class="mb-0">{{ vBillingContact.primary_email }}</p>
                    </template>
                    <template v-else-if="vCustomer?.id">
                      <p class="mb-0 red--text">Please select contact person</p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select customer</p>
                    </template>
                  </v-col>
                  <v-col md="6">
                    <v-layout class="align-center">
                      <v-flex md3
                        ><label class="my-0">Site Location</label></v-flex
                      >
                      <v-flex md9 class="position-relative">
                        <v-icon
                          small
                          v-on:click="openDialog('property')"
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        >
                      </v-flex>
                    </v-layout>

                    <template v-if="vProperty?.id">
                      <span v-if="vProperty && vProperty.property_address">
                        <!--   <v-icon small>mdi-map-marker</v-icon>--></span
                      >
                      <p
                        class="mr-2"
                        v-if="vProperty && vProperty.property_address"
                      >
                        <template>
                          <div
                            class="custom-flex-d"
                            v-if="vProperty?.property_name"
                          >
                            <b>
                              <v-icon
                                style="
                                  font-size: 18px;
                                  margin-top: -3px !important;
                                "
                                color="#000"
                                class="cmt-2"
                              >
                                mdi-home-map-marker
                              </v-icon>
                            </b>
                            <span>{{ vProperty?.property_name }}<br /></span>
                          </div>
                          <div v-else>
                            <em class="text-muted">
                              <v-icon
                                style="
                                  font-size: 18px;
                                  margin-top: -3px !important;
                                "
                                color="#000"
                                class="cmt-2"
                              >
                                mdi-home-map-marker
                              </v-icon>
                              no Site Name</em
                            >
                          </div>
                        </template>

                        <template>
                          <div class="custom-flex-d">
                            <b>
                              <v-icon
                                style="font-size: 18px; margin-top: -3px"
                                color="#000"
                                class="cmt-2"
                              >
                                mdi-map-marker
                              </v-icon>
                            </b>
                            <span>
                              <template v-if="vProperty?.unit_no"
                                >{{ vProperty?.unit_no }},</template
                              >
                              <template v-if="vProperty?.street_1"
                                >{{ vProperty?.street_1 }},</template
                              >
                              {{ vProperty?.street_2 }}
                              <br />
                              {{ vProperty?.country }}
                              <template
                                v-if="
                                  vProperty?.zip_code &&
                                  vProperty?.zip_code != '000000'
                                "
                              >
                                {{ vProperty?.zip_code }}
                              </template>
                            </span>
                          </div>
                        </template>
                      </p>
                    </template>
                    <template v-else-if="vCustomer?.id">
                      <p class="mb-0 red--text">Please select site location</p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select customer</p>
                    </template>

                    <v-layout class="mt-3 align-center">
                      <v-flex md3
                        ><label class="my-0">Contact Details</label></v-flex
                      >
                      <v-flex md9 class="position-relative">
                        <v-icon
                          small
                          v-on:click="openDialog('property-contact')"
                          class="py-0 my-0"
                          color="cyan"
                          style="position: absolute; top: -8px"
                          >mdi-pencil</v-icon
                        >
                      </v-flex>
                    </v-layout>

                    <template v-if="vPropertyContact?.id">
                      <p class="mb-0">{{ vPropertyContact.display_name }}</p>
                      <p class="mb-0">{{ vPropertyContact.primary_phone }}</p>
                      <p class="mb-0">{{ vPropertyContact.primary_email }}</p>
                    </template>
                    <template v-else-if="vCustomer?.id">
                      <p class="mb-0 red--text">Please select contact person</p>
                    </template>
                    <template v-else>
                      <p class="mb-0 red--text">Please select customer</p>
                    </template>
                  </v-col>
                </v-row>
              </v-col>
              <v-col md="5">
                <table width="100%" style="table-layout: fixed">
                  <tr width="150" class="">
                    <td width="200">
                      <label class="font-size-16 pb-0">Date</label>
                    </td>
                    
                    <td colspan="2">
                      <DatePicker :formLoading="formLoading" solo
                      :placeholder="'Start Date *'" :default-date="projectCreate.date" 
                      v-model="projectCreate.date" mandatory: true />
                    </td>
                  </tr>
                  <tr width="150" class="">
                    <td width="200">
                      <label class="font-size-16 pb-0">Duration </label>
                    </td>
                    <td class="pb-0">
                      <v-text-field
                        dense
                        color="cyan"
                        filled
                        :disabled="formLoading"
                        :loading="formLoading"
                        type="number"
                        class="text-capitalize"
                        v-model="projectCreate.project_duration"
                        v-model.trim.number.lazy="
                          projectCreate.project_duration
                        "
                        label="Duration"
                        v-on:keypress="isNumber($event)"
                        :rules="[
                          validateRules.required(
                            projectCreate.project_duration,
                            'Duration'
                          ),
                        ]"
                        solo
                        flat
                        hide-details
                        v-on:keyup="updateDuration('project_duration')"
                      ></v-text-field>
                    </td>
                    <td class="pb-0">
                      <v-select
                        :items="frequencyList"
                        v-model="projectCreate.project_frequency"
                        hide-details
                        label="Frequency"
                        dense
                        filled
                        solo
                        flat
                        item-color="cyan"
                        color="cyan"
                        content-class="custom-placeholder"
                        :rules="[
                          validateRules.required(
                            projectCreate.project_frequency,
                            'Frequency'
                          ),
                        ]"
                        v-on:change="updateDuration('project_duration')"
                      />
                    </td>
                  </tr>
                  <tr width="150" class="">
                    <td width="200">
                      <label class="font-size-16 pb-0">Dates </label>
                    </td>
                    <td class="pb-0">
                      <DatePicker :formLoading="formLoading" solo
                      :placeholder="'Start Date *'" :default-date="projectCreate.started_at"
                      v-model="projectCreate.started_at" mandatory: true
                      v-on:change=" updateDuration('project_duration')" />
                    </td>
                    <td class="pb-0">
                      <DatePicker :formLoading="formLoading" solo
                      :placeholder="'Start Date *'" :default-date="
                      projectCreate.deadline " v-model="projectCreate.deadline"
                      disabled mandatory: true />
                    </td>
                  </tr>
                  <!--  <tr width="150" class="">
                    <td width="200">
                      <label class="font-size-16 pb-0 required"
                        >Start Date
                      </label>
                    </td>
                    <td colspan="2" class="pb-0">
                      <DatePicker :formLoading="formLoading" solo
                      :placeholder="'Start Date *'" :default-date="
                      projectCreate.started_at "
                      v-model="projectCreate.started_at" mandatory: true />
                    </td>
                  </tr>
                  <tr>
                    <td width="200">
                      <label class="font-size-16 pb-0 required">End Date</label>
                    </td>
                    <td colspan="2" class="pb-0">
                      <DatePicker :formLoading="formLoading" solo
                      :placeholder="'End Date'" :default-date="
                      projectCreate.deadline "
                      :min-date="projectCreate.started_at"
                      v-model="projectCreate.deadline" mandatory: true />
                    </td>
                  </tr>
 -->
                  <tr>
                    <td width="200">
                      <label class="font-size-16 pb-0 required"
                        >Commencement Date
                      </label>
                    </td>
                    <td colspan="2" class="pb-0">
                      <DatePicker :formLoading="formLoading" solo
                      :placeholder="'Commencement Date *'" :default-date="
                      projectCreate.commencement_date"
                      v-model="projectCreate.commencement_date" mandatory: true
                      />
                    </td>
                  </tr>

                  <tr>
                    <td class="font-size-16 pb-0" width="200">
                      Customer Purchase Order
                    </td>
                    <td colspan="2" class="pb-0">
                      <v-text-field
                        dense
                        color="cyan"
                        filled
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model.trim="projectCreate.customer_purchase_order"
                        label="Customer Purchase Order"
                        :rules="[
                          validateRules.minLength(
                            projectCreate.customer_purchase_order,
                            'Customer Purchase Order',
                            1
                          ),
                          validateRules.maxLength(
                            projectCreate.customer_purchase_order,
                            'ReferenCustomer Purchase Orderce',
                            100
                          ),
                        ]"
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr>
                    <td class="font-size-16 pb-0" width="200">Reference #</td>
                    <td colspan="2" class="pb-0">
                      <v-text-field
                        dense
                        color="cyan"
                        filled
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model.trim="projectCreate.reference"
                        label="Reference #"
                        :rules="[
                          validateRules.minLength(
                            projectCreate.reference,
                            'Reference',
                            1
                          ),
                          validateRules.maxLength(
                            projectCreate.reference,
                            'Reference',
                            100
                          ),
                        ]"
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr>
                    <td class="font-size-16 pb-2" width="200">Project Value</td>
                    <td colspan="2" class="pb-0" valign="top">
                      <v-text-field
                        dense
                        color="cyan"
                        filled
                        :disabled="formLoading"
                        readonly
                        :loading="formLoading"
                        type="number"
                        v-on:keypress="
                          limitDecimal($event, projectCreate.project_value)
                        "
                        v-on:keyup="projectValue"
                        v-model="projectCreate.project_value"
                        v-model.trim.number.lazy="projectCreate.project_value"
                        label="Project Value"
                        :rules="[
                          validateRules.minLength(
                            projectCreate.project_value,
                            'Project Value',
                            1
                          ),
                          validateRules.maxLength(
                            projectCreate.project_value,
                            'Project Value',
                            100
                          ),
                        ]"
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>

                  <tr>
                    <td class="font-size-16 pb-0" width="200">
                      Project Budget
                    </td>
                    <td
                      colspan="2"
                      v-on:keyup="projectValue"
                      class="pb-0"
                      valign="top"
                    >
                      <v-text-field
                        dense
                        color="cyan"
                        filled
                        :disabled="formLoading"
                        :loading="formLoading"
                        type="number"
                        v-on:keypress="
                          limitDecimal($event, projectCreate.project_budget)
                        "
                        v-model="projectCreate.project_budget"
                        v-model.trim.number.lazy="projectCreate.project_budget"
                        label="Project Budget"
                        :rules="[
                          validateRules.minLength(
                            projectCreate.project_budget,
                            'Project Budget',
                            1
                          ),
                          validateRules.maxLength(
                            projectCreate.project_budget,
                            'Project Budget',
                            100
                          ),
                        ]"
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-size-16 pb-0" width="200">Managers</td>
                    <td colspan="2" class="pb-0" valign="top">
                      <v-autocomplete
                        dense
                        color="cyan"
                        filled
                        :items="managersList"
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model.trim="projectCreate.managers"
                        label="Managers"
                        solo
                        flat
                        item-color="cyan"
                        item-text="full_name"
                        item-value="id"
                        hide-details
                        multiple
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index === 0">
                            <span>{{ item.full_name }}</span>
                          </v-chip>
                          <span
                            v-if="index === 1"
                            class="grey--text font-size-12"
                          >
                            (+{{ projectCreate.managers.length - 1 }} others)
                          </span>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="'No Member Found.'"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-size-16 pb-0" width="200">Technicians</td>
                    <td colspan="2" class="pb-0" valign="top">
                      <v-autocomplete
                        dense
                        color="cyan"
                        filled
                        :items="memberList"
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model.trim="projectCreate.members"
                        label="Technicians"
                        solo
                        flat
                        item-color="cyan"
                        item-text="full_name"
                        item-value="id"
                        hide-details
                        multiple
                      >
                        <template v-slot:selection="{ item, index }">
                          <v-chip v-if="index === 0">
                            <span>{{ item.full_name }}</span>
                          </v-chip>
                          <span
                            v-if="index === 1"
                            class="grey--text font-size-12"
                          >
                            (+{{ projectCreate.members.length - 1 }} others)
                          </span>
                        </template>
                        <template v-slot:no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="'No Member Found.'"
                              ></v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-autocomplete>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-size-16 pb-0" width="200">
                      <label class="font-size-16 pb-0 required"
                        >Project Type</label
                      >
                    </td>
                    <td colspan="2" class="pb-0">
                      <v-select
                        :items="projectTypeList"
                        v-model="projectCreate.project_type"
                        hide-details
                        label="Project Type"
                        dense
                        filled
                        solo
                        flat
                        item-color="cyan"
                        color="cyan"
                        content-class="custom-placeholder"
                        :rules="[
                          validateRules.required(
                            projectCreate.project_type,
                            'Project Type'
                          ),
                        ]"
                        v-on:change="
                          update_term_condition(projectCreate.project_type)
                        "
                      />
                    </td>
                  </tr>
                  <tr>
                    <td class="font-size-16 pb-0" width="200">
                      <label class="font-size-16 pb-0 required"
                        >Billing Frequency</label
                      >
                    </td>
                    <td colspan="2" class="pb-0">
                      <v-select
                        :items="frequencyList"
                        v-model="projectCreate.frequency"
                        hide-details
                        label="Frequency"
                        dense
                        filled
                        solo
                        flat
                        item-color="cyan"
                        color="cyan"
                        content-class="custom-placeholder"
                        :rules="[
                          validateRules.required(
                            projectCreate.frequency,
                            'Frequency'
                          ),
                        ]"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td class="font-size-16 pb-0" width="200">
                      <label class="font-size-16 pb-0 required"
                        >Contract Period Frequency</label
                      >
                    </td>
                    <td colspan="2" class="pb-0">
                      <v-select
                        :items="frequencyList"
                        v-model="projectCreate.contract_frequency"
                        hide-details
                        label="Contract Period Frequency"
                        dense
                        filled
                        solo
                        flat
                        item-color="cyan"
                        color="cyan"
                        content-class="custom-placeholder"
                        :rules="[
                          validateRules.required(
                            projectCreate.contract_frequency,
                            'Frequency'
                          ),
                        ]"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td class="font-size-16 pb-2" width="200">
                      <label class="font-size-16 pb-0 required"
                        >Contract No. of
                        {{ getRename(projectCreate.contract_frequency) }}</label
                      >
                    </td>
                    <td colspan="2" class="pb-0" valign="top">
                      <v-text-field
                        dense
                        color="cyan"
                        filled
                        :disabled="formLoading"
                        :loading="formLoading"
                        class="text-capitalize"
                        v-model="projectCreate.contract_years"
                        v-model.trim.number.lazy="projectCreate.contract_years"
                        :label="`Contract No. of ${projectCreate.contract_frequency}`"
                        v-on:keypress="isNumber($event)"
                        :rules="[
                          validateRules.required(
                            projectCreate.contract_years,
                            'Contract No. of Years'
                          ),
                        ]"
                        solo
                        flat
                        hide-details
                        v-mask="'##'"
                      ></v-text-field>
                    </td>
                  </tr>
                  <tr>
                    <td class="font-size-16 pb-2" width="200">
                      <label class="font-size-16 pb-0 required"
                        >Payable Duration</label
                      >
                    </td>
                    <td colspan="2" class="pb-0" valign="top">
                      <v-text-field
                        dense
                        color="cyan"
                        filled
                        :disabled="formLoading"
                        :loading="formLoading"
                        v-model="projectCreate.payable_duration"
                        label="Payable Duration"
                        :rules="[
                          validateRules.required(
                            projectCreate.payable_duration,
                            'Payable Duration'
                          ),
                        ]"
                        solo
                        flat
                        hide-details
                      ></v-text-field>
                    </td>
                  </tr>
                </table>
                <table width="100%">
                  <tr>
                    <td width="200" class="font-size-16 pb-2">
                      <label class="font-size-16 pb-0"
                        >Is there Optional Period ?</label
                      >
                    </td>
                    <td class="font-size-16 pb-2" colspan="2">
                      <v-switch
                        v-model.trim="projectCreate.is_optional_period"
                        inset
                        :true-value="1"
                        :false-value="0"
                        color="green"
                        hide-details
                        class="mt-0"
                      ></v-switch>
                    </td>
                  </tr>
                  <template v-if="projectCreate.is_optional_period">
                    <tr width="150" class="">
                      <td width="200">
                        <label class="font-size-16 pb-0">Duration </label>
                      </td>
                      <td class="pb-0">
                        <v-text-field
                          dense
                          color="cyan"
                          filled
                          :disabled="formLoading"
                          :loading="formLoading"
                          type="number"
                          class="text-capitalize"
                          v-model="projectCreate.optional_period_duration"
                          v-model.trim.number.lazy="
                            projectCreate.optional_period_duration
                          "
                          label="Duration"
                          v-on:keypress="isNumber($event)"
                          v-on:keyup="updateDuration('optional_period')"
                          solo
                          flat
                          hide-details
                        ></v-text-field>
                      </td>
                      <td class="pb-0">
                        <v-select
                          :items="frequencyList"
                          v-model="projectCreate.optional_period_frequency"
                          hide-details
                          label="Frequency"
                          dense
                          filled
                          solo
                          flat
                          item-color="cyan"
                          color="cyan"
                          content-class="custom-placeholder"
                          v-on:change="updateDuration('optional_period')"
                          :rules="[
                            validateRules.required(
                              projectCreate.optional_period_frequency,
                              'Frequency'
                            ),
                          ]"
                        />
                      </td>
                    </tr>
                    <tr width="150" class="">
                      <td width="200">
                        <label class="font-size-16 pb-0">Dates </label>
                      </td>
                      <td class="pb-0">
                        <DatePicker :formLoading="formLoading" solo
                        :placeholder="'Start Date *'"
                        :default-date="projectCreate.optional_period_date" v-on:change="
                        updateDuration('optional_period') "
                        v-model="projectCreate.optional_period_date" mandatory:
                        true />
                      </td>
                      <td class="pb-0">
                        <DatePicker :formLoading="formLoading" solo
                        :placeholder="'End Date *'" :default-date="
                        projectCreate.optional_period_end_date "
                        v-model="projectCreate.optional_period_end_date"
                        disabled mandatory: true />
                      </td>
                    </tr>
                  </template>
                </table>
              </v-col>
              <v-col cols="12" ref="qtLineItem">
                <v-card flat class="custom-grey-border remove-border-radius">
                  <v-card-title
                    class="headline grey lighten-4"
                    @click="show_line_items = !show_line_items"
                  >
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      <v-icon>{{
                        !show_line_items ? "mdi-chevron-down" : "mdi-chevron-up"
                      }}</v-icon>
                      Line Items
                    </h3>
                  </v-card-title>
                  <v-expand-transition>
                    <v-card-text
                      v-show="show_line_items"
                      ref="lineItem"
                      class="font-size-16 py-0"
                    >
                      <line-item
                        :lift-test-loads="liftTestLoads"
                        v-if="related_type > 0"
                        :related-type="related_type"
                        is-project
                        :unit="unit"
                        :related-detail="updatedProjectData"
                        :db-line-items="[]"
                        :db-equipments="[]"
                        :contract-years="Number(projectCreate.contract_years)"
                        :contract-frequency="projectCreate.contract_frequency"
                      />
                    </v-card-text>
                  </v-expand-transition>
                </v-card>
              </v-col>
              <v-col
                :cols="projectCreate?.project_type == 'comprehensive' ? 6 : 12"
                ref="qtTermsConditions"
              >
                <v-card
                  flat
                  class="custom-grey-border remove-border-radius"
                  style="min-height: 532px"
                >
                  <v-card-title class="headline grey lighten-4">
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      TERMS &amp; CONDITIONS
                    </h3>
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16 sor-scroll">
                    <tinymce-editor
                      :api-key="$tinyMCEAPIKey"
                      v-model="projectCreate.term_conditions"
                      :init="tinyInit"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col
                cols="6"
                ref="projectsor"
                v-if="projectCreate?.project_type == 'comprehensive'"
              >
                <v-card
                  flat
                  class="custom-grey-border remove-border-radius"
                  style="min-height: 532px"
                >
                  <v-card-title class="headline grey lighten-4">
                    <h3
                      class="font-weight-700 custom-headline color-custom-blue"
                    >
                      Schedule of Rate (SOR)
                    </h3>
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <tinymce-editor
                      :api-key="$tinyMCEAPIKey"
                      v-model="projectCreate.sor"
                       :init="tinyInit"
                    />
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" ref="qtNote">
                <v-container fluid>
                  <v-card flat class="custom-grey-border remove-border-radius">
                    <v-card-text class="p-6 font-size-16">
                      <v-layout class="mt-4">
                        <v-flex md12>
                          <DocumnetList
                            v-model="projectCreate.project_attachments"
                            :document-type="111"
                          >
                          </DocumnetList>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-container>
              </v-col>
            </v-row>
          </v-form>

          <customer-select
            :dialog="reCustomerDialog"
            @close="closeCustomerDialog"
          />
          <customer-create :key="`project-customer-create-${dialog_key}`" />
          <person-select
            :dialog="contactDialog"
            v-on:close="contactDialog = false"
            :type="contactType"
          />
          <address-select
            :dialog="propertyDialog"
            v-on:close="propertyDialog = false"
            :type="propertyType"
            :label="propertyLabel"
          />
        </div>
      </perfect-scrollbar>
    </template>
  </CreateUpdateTemplate>
</template>

<script>
import CreateUpdateTemplate from "@/view/pages/partials/Create-Update-Template.vue";
import { PreventDialogEventBus } from "@/core/lib/prevent.reload.lib";
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ValidationMixin from "@/core/plugins/validation-mixin";
import LineItemV2 from "@/view/pages/partials/Line-Item-Projects.vue";
/* import TinyMCE from "@/view/pages/partials/TinyMCE.vue"; */
import moment from "moment-timezone";
import ObjectPath from "object-path";
import {
  SET_DIALOG_STATUS,
  SET_CREATE_DIALOG_STATUS,
  CLEAR_CUSTOMER,
} from "@/core/services/store/customer.module";
import {
  SET_CUSTOMER,
  SET_PROPERTY,
  SET_PROPERTY_CONTACT,
  SET_BILLING,
  SET_BILLING_CONTACT,
  RESET_CREATE_STATE,
} from "@/core/services/store/visit.module";
import {
  QUERY,
  POST,
  CLEAR_ERROR,
  PUT,
  GET,
} from "@/core/services/store/request.module";
import CustomerSelect from "@/view/components/CustomerSelect.vue";
import CustomerCreate from "@/view/components/CustomerCreateDialog.vue";
import PersonSelect from "@/view/components/PersonSelect.vue";
import AddressSelect from "@/view/components/AddressSelect.vue";
import { ErrorEventBus, InitializeError } from "@/core/lib/message.lib";
import KTCookie from "@/assets/js/components/cookie";
import DocumnetList from "@/view/pages/DocumnetList";
import TextAreaField from "@/view/components/app-component/TextAreaField.vue";
import CommonMixin from "@/core/plugins/common-mixin";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
import DatePicker from "@/view/pages/partials/Datepicker.vue";
import TinyMCEEditor from "@tinymce/tinymce-vue";

export default {
  name: "project-create",
  title: "Create Project",
  mixins: [ValidationMixin, CommonMixin],
  data() {
    return {
      tinyInit: {
        height: 420,
        menubar: true,
        plugins: `
          table lists link image code autoresize
        `,
        toolbar: `
          undo redo | formatselect | bold italic underline |
          alignleft aligncenter alignright |
          bullist numlist |
          table |
          tableprops tablerowprops tablecellprops |
          tableinsertrowbefore tableinsertrowafter |
          tabledeleterow |
          tableinsertcolbefore tableinsertcolafter |
          tabledeletecol |
          removeformat code
        `,
        table_toolbar: `
          tableprops tablerowprops tablecellprops |
          tableinsertrowbefore tableinsertrowafter tabledeleterow |
          tableinsertcolbefore tableinsertcolafter tabledeletecol
        `,
        content_style: `
        body { overflow-y:auto !important; }
      `,
      },
      defaultDate: moment().format("YYYY-MM-DD"),
      projectCreate: new Object({
        name: null,
        description: null,
        project_attachments: [],
        barcode: null,
        started_at: moment().format("YYYY-MM-DD"),
        date: moment().format("YYYY-MM-DD"),
        deadline: null,
        commencement_date: moment().format("YYYY-MM-DD"),
        status: 0,
        customer_purchase_order: null,
        reference: null,
        project_value: null,
        project_budget: null,
        members: [],
        managers: [],
        specification: null,
        bank_name: null,
        bank_amount: null,
        bank_remark: null,
        bank_attachments: [],
        insurance_company: null,
        insurance_amount: null,
        insurance_remark: null,
        insurance_attachments: [],
        customer: null,
        property: null,
        billing: null,
        property_contact_person: null,
        billing_contact_person: null,
        frequency: null,
        contract_years: null,
        payable_duration: null,
        project_type: "comprehensive",
        term_condition_id: 0,
        term_conditions: null,
        sor: null,
        project_duration: 1,
        project_frequency: "yearly",
        contract_frequency: "yearly",
        is_optional_period: 0,
        optional_period_duration: 1,
        optional_period_frequency: "yearly",
        optional_period_date: moment().format("YYYY-MM-DD"),
        optional_period_end_date: null,
      }),
      liftTestLoads: [],
      termsConditionList: [],
      updatedProjectData: {},
      memberList: [],
      managersList: [],
      projectTypeList: [
        { text: "Comprehensive", value: "comprehensive" },
        { text: "Non-Comprehensive", value: "non-comprehensive" },
      ],
      frequencyList: [
        { text: "Weekly", value: "weekly" },
        { text: "Monthly", value: "monthly" },
        { text: "Bi-Monthly", value: "bi-monthly" },
        { text: "Quarterly", value: "quarterly" },
        { text: "Yearly", value: "yearly" },
      ],
     /*  contractFrequencyList: [
        { text: "Weekly", value: "weekly" },
        { text: "Monthly", value: "monthly" },
        { text: "Yearly", value: "yearly" },
        { text: "Quarterly", value: "quarterly" },
        { text: "Yearly", value: "yearly" },
      ], */
      related_type: 8,
      project: 0,
      unit: [],
      schedule_key: Number(new Date()),
      dialog_key: Number(new Date()),
      formLoading: false,
      formValid: true,
      projectCreated: false,
      show_line_items: true,
      show_terms_condition: false,
      project_Id: 0,

      attachments: [
        {
          accepted_file: null,
          file_name: null,
          file_type: null,
        },
      ],
      dbEquipments: [],
      todayDate: null,
      propertyType: null,
      propertyLabel: null,
      propertyDialog: false,
      contactType: null,
      contactDialog: false,
    };
  },
  watch: {
    vSelectedLineItem: {
      deep: true,
      handler(items) {
        const total = items.reduce((sum, item) => {
          return (
            sum +
            (item.yearly_costs || []).reduce((t, y) => {
              return t + Number(y.total_cost || 0);
            }, 0)
          );
        }, 0);

        this.projectCreate.project_value = total;
      },
    },
    "projectCreate.started_at": {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.updateDuration("project_duration");
        }
      },
    },

    "projectCreate.optional_period_date": {
      deep: true,
      immediate: true,
      handler(param) {
        if (param) {
          this.updateDuration("optional_period");
        }
      },
    },
    formValid(param) {
      if (param) {
        this.$store.dispatch(CLEAR_ERROR, {});
      }
    },
    duplicate(param) {
      if (param > 0) {
        this.getProject(param);
      }
    },
    project(param) {
      if (param > 0) {
        this.getProject(param);
        this.$store.dispatch(SET_BREADCRUMB, [
          { title: "Project", route: "project" },
          { title: "update" },
        ]);
      }
    },
  },
  components: {
    "customer-select": CustomerSelect,
    "customer-create": CustomerCreate,
    "person-select": PersonSelect,
    "address-select": AddressSelect,
    "line-item": LineItemV2,
    /*   "tiny-mce": TinyMCE, */
    // "file-upload": FileUpload,
    TextAreaField,
    CreateUpdateTemplate,
    DocumnetList,
    DatePicker,
    "tinymce-editor": TinyMCEEditor,
  },
  methods: {
    calcTotalYearlyCost() {
      this.projectCreate.project_value = (this.vSelectedLineItem || []).reduce(
        (sum, item) => {
          return (
            sum +
            (item.yearly_costs || []).reduce((t, y) => {
              return t + Number(y.total_cost || 0);
            }, 0)
          );
        },
        0
      );
    },
    getRename(text) {
      switch (text) {
        case "weekly":
          return "Weeks";

        case "monthly":
          return "Months";

        case "bi-monthly":
          return "Bi-Month";

        case "quarterly":
          return "Quarter";

        case "yearly":
          return "Years";

        default:
          return text;
      }
    },
    updateDuration(type) {
      const isProject = type === "project_duration";

      const startDate = isProject
        ? this.projectCreate?.started_at
        : this.projectCreate?.optional_period_date;

      if (!startDate) return;

      const duration = this.lodash.toSafeInteger(
        isProject
          ? this.projectCreate.project_duration
          : this.projectCreate.optional_period_duration
      );

      const frequency = isProject
        ? this.projectCreate.project_frequency
        : this.projectCreate.optional_period_frequency;

      let date = moment(startDate, "YYYY-MM-DD");

      const frequencyMap = {
        weekly: { value: 1, unit: "weeks" },
        monthly: { value: 1, unit: "months" },
        "bi-monthly": { value: 2, unit: "months" },
        quarterly: { value: 3, unit: "months" },
        yearly: { value: 1, unit: "years" },
      };

      if (frequencyMap[frequency]) {
        const { value, unit } = frequencyMap[frequency];
        date.add(duration * value, unit);
      }

      date.subtract(1, "days");

      const formatted = date.format("YYYY-MM-DD");

      if (isProject) {
        this.projectCreate.deadline = this.lodash.cloneDeep(formatted);
      } else {
        this.projectCreate.optional_period_end_date =
          this.lodash.cloneDeep(formatted);
      }
    },
    update_term_condition(type) {
      let typeNew = null;
      if (type == "comprehensive") {
        typeNew = "Comprehensive";
      } else {
        typeNew = "Non Comprehensive";
      }

      let output = this.lodash.find(this.termsConditionList, {
        label: typeNew,
      });

      if (output) {
        this.projectCreate.term_conditions = output.description;
      }

      /*   this.generateDurationStatement(); */
    },
    projectValue() {
      if (
        this.projectCreate.project_budget >
        (this.projectCreate.project_value && this.projectCreate.project_value)
      ) {
        this.projectCreate.project_budget = this.projectCreate.project_value;
        return false;
      }
    },
    createCustomerDialog() {
      this.dialog_key = Number(new Date());
      this.$nextTick(() => {
        this.$store.commit(SET_CREATE_DIALOG_STATUS, true);
      });
    },

    closeCustomerDialog() {
      this.$store.commit(SET_DIALOG_STATUS, false);
    },
    openDialog(type) {
      this.$store.commit(SET_DIALOG_STATUS, false);
      this.propertyType = null;
      this.propertyLabel = null;
      this.propertyDialog = false;
      this.contactType = null;
      this.contactDialog = false;

      if (type == "customer") {
        this.$store.commit(SET_DIALOG_STATUS, true);
      } else {
        if (!this.vCustomerId) {
          ErrorEventBus.$emit("update:error", "Please Select Customer.");
          return false;
        }
        if (type == "billing") {
          this.propertyType = "billing";
          this.propertyLabel = "Billing Location";
          this.propertyDialog = true;
        }
        if (type == "billing-contact") {
          this.contactType = "billing";
          this.contactDialog = true;
        }
        if (type == "property") {
          this.propertyType = "property";
          this.propertyLabel = "Service Location";
          this.propertyDialog = true;
        }
        if (type == "property-contact") {
          this.contactType = "property";
          this.contactDialog = true;
        }
      }
    },
    validateJob() {
      if (!this.vCustomerId) {
        ErrorEventBus.$emit("update:error", "Select Customer");
        return false;
      }

      if (!this.vPropertyId) {
        ErrorEventBus.$emit("update:error", "Select Service Location");
        return false;
      }

      if (!this.vPropertyContactId) {
        ErrorEventBus.$emit("update:error", "Select Service Contact Person");
        return false;
      }

      if (!this.vBillingId) {
        ErrorEventBus.$emit("update:error", "Select Billing Location");
        return false;
      }

      if (!this.vBillingContactId) {
        ErrorEventBus.$emit("update:error", "Select Billing Contact Person");
        return false;
      }

      const allHeaders = this.vSelectedLineItem.every(
        (obj) => obj.type === "header"
      );
      if (
        !this.vSelectedLineItem ||
        !this.vSelectedLineItem.length ||
        allHeaders
      ) {
        ErrorEventBus.$emit("update:error", "Select Line Item");
        return false;
      }
      const AllItems = this.vSelectedLineItem;
      if (AllItems?.length > 0) {
        for (var k = 0; k < AllItems.length; k++) {
          if (!AllItems[k].product) {
            ErrorEventBus.$emit(
              "update:error",
              AllItems[k].type + " title is required."
            );
            return false;
          }
        }
      }
      const validateStatus = this.$refs.projectForm.validate();

      const formErrors = this.validateForm(this.$refs.projectForm);

      if (formErrors.length) {
        for (let i = 0; i < formErrors.length; i++) {
          ErrorEventBus.$emit("update:error", InitializeError(formErrors[i]));
        }
        return false;
      }

      if (validateStatus) {
        this.onSubmit();
      }
    },
    onSubmit() {
      const _this = this;

      _this.$store.dispatch(CLEAR_ERROR, {});

      _this.formLoading = true;

      let REQUEST_TYPE = POST;
      let REQUEST_URL = "projects";

      if (_this.project && _this.project > 0) {
        REQUEST_TYPE = PUT;
        REQUEST_URL = "projects/" + _this.project;
      }

      const calc = this.vCalculations || {};

      const requestData = {
        ...this.projectCreate,
        customer: this.vCustomerId,
        property: this.vPropertyId,
        billing: this.vBillingId,
        property_contact_person: this.vPropertyContactId,
        billing_contact_person: this.vBillingContactId,

        discount_value: calc.discount_value
          ? parseFloat(calc.discount_value)
          : 0,
        tax_applied: calc.tax_active === true ? 1 : 0,
        discount_type:
          calc.discount_level && calc.discount_level === "transaction" ? 1 : 2,
        discount_value_type: calc.discount_type
          ? parseInt(calc.discount_type)
          : 0,
        tax_value: calc.tax_value ? parseFloat(calc.tax_value) : 0,
        show_price: calc.show_price && calc.show_price === true ? 1 : 0,
        adjustment: calc.adjustment ? parseFloat(calc.adjustment) : 0,
        ctx_discount_label: calc.ctx_discount_label
          ? String(calc.ctx_discount_label)
          : null,
        ctx_discount_value:
          calc.ctx_discount_value && calc.ctx_discount_value !== ""
            ? parseFloat(calc.ctx_discount_value)
            : 0,
        ctx_discount_type: calc.ctx_discount_type
          ? parseInt(calc.ctx_discount_type)
          : 0,
        "line-item": this.vSelectedLineItem,
      };

      _this.$store
        .dispatch(REQUEST_TYPE, {
          url: REQUEST_URL,
          data: requestData,
        })
        .then(({ data }) => {
          _this.projectCreated = true;
          _this.$router.push(
            _this.getDefaultRoute("project.detail", {
              params: { id: data.id },
            })
          );
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.formLoading = false;
        });
    },
    getProject(projectId) {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "projects/" + projectId,
        })
        .then(({ data }) => {
          this.updatedProjectData = ObjectPath.get(data);
          _this.projectCreate.project = data.project;
          _this.projectCreate.barcode = data.barcode;
          _this.projectCreate.name = data.name;
          _this.projectCreate.description = data.description;

          _this.projectCreate.customer =
            data && data.customer && data.customer.id;
          _this.projectCreate.property =
            data && data.property && data.property.id;
          _this.projectCreate.billing = data && data.billing && data.billing.id;
          _this.projectCreate.customer_purchase_order =
            data.customer_purchase_order;
          _this.projectCreate.reference = data.reference;
          _this.projectCreate.project_value = data.project_value;
          _this.projectCreate.project_budget = data.project_budget;

          _this.projectCreate.specification = data.specification;
          _this.projectCreate.bank_name = data.bank_name;
          _this.projectCreate.bank_amount = data.bank_amount;
          _this.projectCreate.bank_remark = data.bank_remark;

          _this.projectCreate.insurance_company = data.insurance_company;
          _this.projectCreate.insurance_amount = data.insurance_amount;
          _this.projectCreate.insurance_remark = data.insurance_remark;

          _this.projectCreate.attention = data.attention;
          _this.projectCreate.reference = data.reference;
          _this.projectCreate.billing_type = data.billing_type;
          _this.projectCreate.rate_per_hour = data.rate_per_hour || null;
          _this.projectCreate.estimated_hour = data.estimated_hour || null;
          _this.projectCreate.started_at = data.started_at;
          _this.projectCreate.deadline = data.deadline;
          _this.projectCreate.date = data.date;
          _this.projectCreate.commencement_date = data.commencement_date;
          _this.projectCreate.frequency = data.frequency;
          _this.projectCreate.contract_years = data.contract_years;
          _this.projectCreate.payable_duration = data.payable_duration;
          _this.projectCreate.term_conditions = data.term_conditions;
          _this.projectCreate.sor = data.sor;
          _this.projectCreate.project_type = data.project_type;
          _this.projectCreate.status = data.status;
          _this.projectCreate.project_duration = this.lodash.toSafeInteger(
            data.project_duration
          );
          _this.projectCreate.project_frequency = data.project_frequency;
          _this.projectCreate.contract_frequency = data.contract_frequency;
          _this.projectCreate.is_optional_period = this.lodash.toSafeInteger(
            data.is_optional_period
          );
          _this.projectCreate.optional_period_duration =
            this.lodash.toSafeInteger(data.optional_period_duration);
          _this.projectCreate.optional_period_frequency =
            data.optional_period_frequency;
          _this.projectCreate.optional_period_date = data.optional_period_date;
          _this.projectCreate.optional_period_end_date =
            data.optional_period_end_date;

          if (data.members && data.members.length > 0) {
            _this.projectCreate.members = data.members.map((row) => {
              return row.user.id;
            });
          }
          if (data?.managers && data.managers?.length > 0) {
            _this.projectCreate.managers = data.managers.map((row) => {
              return row.user.id;
            });
          }

          this.$store.commit(SET_CUSTOMER, data?.customer_relation);
          this.$store.commit(SET_PROPERTY, data?.property_relation);
          this.$store.commit(
            SET_PROPERTY_CONTACT,
            data?.property_contact_person_relation
          );
          this.$store.commit(SET_BILLING, data?.billing_relation);
          this.$store.commit(
            SET_BILLING_CONTACT,
            data?.billing_contact_person_relation
          );
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    setStartDate(param) {
      this.projectCreate.started_at = param;
    },
    setDeadline(param) {
      this.projectCreate.deadline = param;
    },
    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(QUERY, {
          url: "project/options",
          data: { customer: _this.customer, property: _this.projectProperty },
        })
        .then(({ data }) => {
          if (!_this.project) {
            _this.projectCreate.barcode = data.barcode;
          }
          _this.barcodeSetting = data.option;
          _this.memberList = data.members;
          _this.managersList = data?.managers;
          _this.unit = data.unit;
          _this.termsConditionList = data.term_condition_list;
          _this.liftTestLoads = data.liftrenewal;

          if (!_this.project) {
            let output = this.lodash.find(this.termsConditionList, {
              type: "sor",
            });
            if (output) {
              this.projectCreate.sor = output.description;
            }
            this.update_term_condition("comprehensive");
          }
        })
        .catch((error) => {
          _this.logError(error);
          _this.goBack();
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
  },

  mounted() {
    this.$refs.projectForm.validate();
    const _this = this;
    _this.getOptions();

    _this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Project", route: "project" },
      { title: "Create" },
    ]);
    this.updateDuration();
    this.calcTotalYearlyCost();
  },
  destroyed() {
    this.$store.dispatch(CLEAR_CUSTOMER);
    this.$store.dispatch(RESET_CREATE_STATE);
  },
  beforeDestroy() {
    KTCookie.setCookie("kt_aside_toggle_state", "off");
    localStorage.setItem("kt_aside_toggle_state", "off");
  },
  created() {
    const _this = this;
    _this.project = _this.lodash.toSafeInteger(_this.$route.params.id);
  },
  beforeCreate() {
    KTCookie.setCookie("kt_aside_toggle_state", "on");
    localStorage.setItem("kt_aside_toggle_state", "on");
    this.$store.dispatch(CLEAR_CUSTOMER);
    this.$store.dispatch(RESET_CREATE_STATE);
    /*  this.$store.dispatch(CLEAR_LINE_ITEM); */
  },
  computed: {
    ...mapGetters([
      "vCustomer",
      "vProperty",
      "vPropertyContact",
      "vBilling",
      "vBillingContact",
      "vCustomerId",
      "vPropertyId",
      "vPropertyContactId",
      "vBillingId",
      "vBillingContactId",
      "reCustomerDialog",
      "vSelectedLineItem",
      "vCalculations",
      "customError",
      "customErrorOcc",
    ]),
  },
  beforeRouteLeave(to, from, next) {
    const _this = this;
    if (_this.projectCreated) {
      next();
    } else {
      _this.routePreventDialog = true;
      PreventDialogEventBus.$on("stay-on-page", function () {
        _this.routePreventDialog = false;
        next(false);
      });
      PreventDialogEventBus.$on("leave-page", function () {
        _this.routePreventDialog = false;
        next();
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.project-create-page {
  border-top: solid 8px #f7941e;

  label {
    padding-left: 5px;
    font-weight: 600;
  }

  p {
    padding-left: 5px;
  }
}

.form-action {
  display: flex;
  justify-content: space-between;

  .form-title {
    font-size: 24px;
    font-family: "Poppins", Helvetica, Arial, sans-serif;
    font-weight: 700;
    color: #24326d;
    letter-spacing: 1.5px;
    line-height: 1.11em;

    .form-title-link {
      color: #4d6974;
      border-bottom: dashed 2px #4d6974;
    }
  }
}
.sor-scroll {
  max-height: 450px;
  overflow-y: auto;
}
</style>
